import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useCmdAuth } from "../contexts/CmdAuthContext";

export default function CmdLogin() {
  const { me, setupNeeded, login } = useCmdAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  if (setupNeeded) return <Navigate to="/cmd/setup" replace />;
  if (me) return <Navigate to="/cmd" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email.trim(), password);
      navigate("/cmd", { replace: true });
    } catch (ex) {
      setErr(ex?.response?.data?.detail || "Could not sign in.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cmd-root">
      <div className="cmd-auth-wrap">
        <form className="cmd-auth-card" onSubmit={submit} data-testid="cmd-login-form">
          <h1>Sign in</h1>
          <p className="sub">EEPL Command Room — one place for every business.</p>
          <div className="cmd-field">
            <label htmlFor="cmd-login-email">Email</label>
            <input
              id="cmd-login-email"
              type="email"
              className="cmd-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              data-testid="cmd-login-email"
            />
          </div>
          <div className="cmd-field">
            <label htmlFor="cmd-login-password">Password</label>
            <input
              id="cmd-login-password"
              type="password"
              className="cmd-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              data-testid="cmd-login-password"
            />
          </div>
          {err && <div className="cmd-error" data-testid="cmd-login-error">{err}</div>}
          <button
            className="cmd-btn cmd-btn-primary"
            type="submit"
            disabled={busy}
            style={{ width: "100%", marginTop: 8 }}
            data-testid="cmd-login-submit"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
